<template>
    <div class="faq-item-container">
        <div class="faq-title" :class="{'active' : isActive}" @click="clickFaq()">
            <div class="text">{{faqItem.title}}</div>
            <div class="icon">
                <img v-if="isActive" src="@/assets/icon/ic-arrw-up.svg" alt="">
                <img v-else src="@/assets/icon/ic-arrw-down.svg" alt="">
            </div>
        </div>
        <div v-show="isActive" class="divider"></div>
        <div v-show="isActive" class="faq-detail" v-html="faqItem.detail"></div>
    </div>
</template>

<script>
export default {
    name: "FaqItem",
    props: {
        faqItem: { type: Object, required: true }
    },
    data: function () {
        return {
            isActive: false,
        }
    },
    methods: {
        clickFaq: function () {
            this.isActive = !this.isActive;
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../style/Faq.scss";
</style>
